"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockProxy = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
class MockProxy {
    constructor(getDataOrConfig, delayTimeout) {
        this.params = {};
        if (typeof getDataOrConfig === 'object') {
            this.name = getDataOrConfig.name;
            this.getData = getDataOrConfig.getData || (() => ({ ok: true }));
            this.delay = typeof getDataOrConfig.delay === 'number' ? getDataOrConfig.delay : 1000;
            this.logRequest =
                getDataOrConfig.logRequest === undefined ? true : !!getDataOrConfig.logRequest;
        }
        else {
            this.getData = getDataOrConfig;
            this.delay = typeof delayTimeout === 'number' ? delayTimeout : 1000;
            this.logRequest = false;
            this.name = '';
        }
    }
    load(payload, loadParams) {
        const params = Object.assign(Object.assign({}, this.params), (loadParams || {}));
        if (this.logRequest) {
            console.info(`[MockProxy ${this.name || 'unknown'}] load with params ${JSON.stringify(params)} and payload: ${JSON.stringify(payload || {})}`);
        }
        return (0, rxjs_1.of)({
            data: this.getData(params, payload),
            meta: { status: 200 }
        }).pipe((0, operators_1.delay)(this.delay));
    }
    /**
     * Set data provider
     */
    setDataProvider(dataProvider) {
        this.getData = dataProvider;
    }
    setParams(params) {
        this.params = params;
    }
}
exports.MockProxy = MockProxy;
//# sourceMappingURL=MockProxy.js.map